module.exports = __webpack_public_path__ + "img/features-2.1a53e309.png";